import React from 'react';
import styled from 'styled-components';
import { RowDiv, Text } from 'styles';

export function SubTitle({ title, desc, type }) {
  return (
    <Conttainer $gap={4} $type={type}>
      <Circle />
      <RowDiv
        $alignItems={(type !== 'product' && 'flex-end') || 'flex-start'}
        $gap={16}
        $mGap={8}
        $flexDirection={type === 'product' && 'column'}
      >
        <h3>{title}</h3>
        <Text $color="primary" $type="b5" $tType="b7">
          {desc}
        </Text>
      </RowDiv>
    </Conttainer>
  );
}

const Conttainer = styled(RowDiv)`
  h3 {
    font-size: 2.375rem;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.primary900};
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $type }) => $type === 'tech' && `padding:0 24px`};
    h3 {
      font-size: 1.25rem;
    }
  }
`;

const Circle = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary100};

  @media ${({ theme }) => theme.device.mobile} {
    width: 16px;
    height: 16px;
  }
`;
